import { Component, OnInit } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { QueryOptions } from '@app/model/query-options';
import { ScheduleInterviewService } from '@app/services/scheduleInterview.service';
import { CommonService } from '@app/services/common.service';
import { RecruiterService } from '@app/services/recruiterService';
import { TechnologyService } from '@app/services/technology.service';
import { JobCategoryService } from '@app/services/jobCategory.service';
import { GenerateExcelService } from '@app/services/generatExcel.service';
import { DatePipe } from '@angular/common';
import { ApplicantService } from '@app/services/applicant.service';
import { Messages } from '@app/constants/constant';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApplicantDataService } from '@app/services/applicantData.service';
import { InterviewStepStatusService } from '@app/services/interviewstep-status.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-view-all-interviews-list',
  templateUrl: './view-all-interviews-list.component.html',
  styleUrls: ['./view-all-interviews-list.component.css']
})
export class ViewAllInterviewsListComponent implements OnInit {
  sortField :any ='startTime' ;
  sortOrder :any ='-1';
  first: number = 0;
  selectedColumns: any[];
  totalRecords: number;
  loading :boolean;
  listPageSize:number=1000;
  pageSize: number = 20;
  records: any=[];
  showTable:boolean=true;
  pageSizeVar: number=25;
  yearFilter: any;
  filter:any={
    categoryFilter:'',
    technologyFilter:'',
    recruiterName:'',
    interviewType :'',
    candidate :'',
    candidateStatus:''
  }
  allInterviewSteps:any;
  recruiterNames:any;
  technologyList: any;
  categoryList: any;
  allCandidateList: any;
  candidateStatusList:any;

   roleArr=[];
   technologyArr=[];
   recruiterArr=[];
   interviewTypeArr=[];
   candidateArr=[];
   candidateStatusArr =[];
   date=null;
   params=null;
   columns = [
    { field: 'startDate', header: 'Date & Time', type: 'date', sort:{required: true,sortBy:'startTime'}  },
    { field: 'interviewerFullName', header: 'Interviewer Name', sort:{required: false} },
    { field: 'assignedRecruiterNames',subfield: 'firstName', header: 'Recruiter Name' , sort:{required: false},params :{type:'jobStatus'}},
    { field: 'interviewStepName', header: 'Interview Type', sort:{required: true,sortBy:'interviewStep.name'},width:"10%"},
    { field: 'interviewStepStatusName', header: 'Interview Step Status', sort:{required: true,sortBy:'interviewStepStatus.name'} },
    { field: 'applicantFullName', header: 'Candidate Name',sort:{required: true,sortBy:'interview.applicant.firstName'} },
    { field: 'applicantPhone', header: 'Mobile No', sort:{required: false}  },
    { field: 'jobCategoryName', header: 'Role' , sort:{required: true,sortBy:'interview.job.jobCategory.name'}},
    { field: 'technologyName', header: 'Technology', sort:{required: true,sortBy:'interview.job.technology.name'} },
    { field: 'candidateStatus', header: 'Candidate Status', sort:{required: true,sortBy:'interview.job.technology.name'} }
  ];
  excelRecords: any;
  newJson: any;
  
  constructor( private _scheduleInterviewService: ScheduleInterviewService,
    private _commonService: CommonService,
    private _recruiterService: RecruiterService,
    private _apiTechnology: TechnologyService,
    private _apiJobCategories: JobCategoryService,
    private _interviewStepStatusService: InterviewStepStatusService,
    private _apiRecruiter: RecruiterService,
    private _DatePipe:DatePipe,
    private _generateExcelService :GenerateExcelService, 
    private spinner: NgxSpinnerService,
    private _router: Router,
    private _applicantService: ApplicantDataService) { }

  ngOnInit() {
    var sortParams= this.queryParams("name",1,this.listPageSize);
    this.selectedColumns = this.columns;
    this._commonService.list(sortParams,'interview-step').subscribe(res => {
      this.allInterviewSteps= res;
    });
    var sortParamsRecruiter= this.queryParams("firstName",1,this.listPageSize);;
    this._apiRecruiter.list(sortParamsRecruiter).subscribe(
      res => {
      this.recruiterNames = res;
    });  
   var params= this.queryParams("name",1,this.listPageSize);
   this._apiTechnology.list(params).subscribe(res => {
     this.technologyList = res;
    });
   this._apiJobCategories.list(params).subscribe(res => {
    this.categoryList = res;
  });
  this._applicantService.list(sortParamsRecruiter,Messages.endpoint.getAllApplicant).subscribe(res => {
    this.allCandidateList= res;
  });

  this._interviewStepStatusService.list(params,'interview-status').subscribe(res => {
    this.candidateStatusList= res;
    });

  var candidateData:any=localStorage.getItem('candidateData');
  if(candidateData != null)
  {
    candidateData = JSON.parse(candidateData);
    this.candidateArr.push(candidateData);
    this.filter.candidate = this.candidateArr;
    localStorage.removeItem('candidateData');
  }

  }

  callService(params){
    this._scheduleInterviewService.list(params,'interview/interview-step-mapping').subscribe(res => {

      this.spinner.hide();
      this.records= res;
      this.totalRecords=res && res.length>0 ? res[0]['totalRecords'] : this.pageSize;
      this.showTable=this.records.length>0?true:false;
    });
  }

  exportExcel() {
      if(this.filter.categoryFilter || this.filter.technologyFilter || this.filter.recruiterName 
        || this.filter.interviewType || this.yearFilter || this.filter.candidate|| this.filter.candidateStatus){
          let dateRange=new Array();
          if(this.yearFilter && this.yearFilter.length>1){
            dateRange.push( this._DatePipe.transform(this.yearFilter[1],'dd/MM/yyyy'));
            dateRange.push(this._DatePipe.transform(this.yearFilter[0],'dd/MM/yyyy'));
            this.date= dateRange.length > 1 ? dateRange[0] +'-'+dateRange[1] : null
          }
     var  params = this.queryParams(this.sortField,this.sortOrder,this.listPageSize,this.filter.categoryFilter,this.filter.technologyFilter,
            this.filter.recruiterName,this.filter.interviewType,this.date, this.returnFilterArray(this.filter.candidateStatus), this.returnFilterArray(this.filter.candidate),'0')
     this._scheduleInterviewService.list(params,'interview/interview-step-mapping').subscribe(res => {
      this.excelRecords= res;
      this._generateExcelService.exportExcel( this.convertJsonDataToExcelRecord(this.excelRecords));});
        }
        else{
          params= this.queryParams(this.sortField,this.sortOrder,this.listPageSize,undefined,undefined,undefined,undefined,undefined,undefined,undefined,'0');
          this._scheduleInterviewService.list(params,'interview/interview-step-mapping').subscribe(res => {
            this.excelRecords= res;
            this._generateExcelService.exportExcel(this.convertJsonDataToExcelRecord(this.excelRecords));});
        }
  }


  onLoad(event?: LazyLoadEvent) {
    this.spinner.show();
    this.sortField = event.sortField == undefined ? 'startTime' : event.sortField;
     this.sortOrder = event.sortOrder ? event.sortOrder : -1;
     this.first = event.first ? event.first: 0;
  let dateRange=new Array();
  if(this.filter.categoryFilter || this.filter.technologyFilter || this.filter.recruiterName || this.filter.interviewType || this.yearFilter || this.filter.candidate || this.filter.candidateStatus){
    if(this.yearFilter && this.yearFilter.length>1){
      dateRange.push( this._DatePipe.transform(this.yearFilter[1],'dd/MM/yyyy'));
      dateRange.push(this._DatePipe.transform(this.yearFilter[0],'dd/MM/yyyy'));
      this.date= dateRange.length > 1 ? dateRange[0] +'-'+dateRange[1] : null
    }
     var params = this.queryParams(this.sortField,this.sortOrder,this.pageSize,
      this.filter.categoryFilter ,this.filter.technologyFilter,this.filter.recruiterName,this.filter.interviewType,this.date,this.returnFilterArray(this.filter.candidateStatus), this.returnFilterArray(this.filter.candidate))
      this.callService(params);
  }
  else {
    params= this.queryParams(this.sortField,this.sortOrder,this.pageSize);
    this.callService(params);
  }
  }

  queryParams(sortFieldName?:string,sortOrder?:any,pageSize?:any,roleArr?:any,technologyArr?:any,recruiterArr?:any,interviewTypeArr?:any,date?:any,candidateStatusArr?:any, candidateArr?:any,pageNo?:any){
    const queryParams = new Object();
      // sort order as number, 1 for asc and -1 for dec
    queryParams['sortParam'] = { sortField:sortFieldName , sortOrder: sortOrder };
    queryParams['pageParam'] = {
    page: pageNo ? pageNo :
        (this.first / this.pageSize),
      size: pageSize? pageSize:this.pageSizeVar,
    };
    if(roleArr || technologyArr || recruiterArr || interviewTypeArr || date || candidateArr || candidateStatusArr){
    queryParams['viewInterviewFilter'] = {'role':roleArr,'technology':technologyArr,'recruiters':recruiterArr,'interviewType':interviewTypeArr,'date':date,'candidate':candidateArr, 'candidateStatus':candidateStatusArr}
    }
    const tableSortingQueryOption = new QueryOptions(queryParams);
    tableSortingQueryOption.toQueryMap();
    return tableSortingQueryOption;
}


clearAllFilter(event){
  this.filter.categoryFilter='';
  this.filter.technologyFilter='';
  this.filter.recruiterName='';
  this.filter.interviewType='';
  this.filter.candidateStatus='';
  this.yearFilter='';
  this.filter.candidate='';
  this.onLoad(event);
}

returnFilterArray(filterArr){
  var filteredArr=[];
  for(var i=0;i<filterArr.length;i++){
    filteredArr.push(filterArr[i].id)
  }
  return filteredArr;
}

convertJsonDataToExcelRecord(records:any): any{
   this.newJson = records.map(rec => {
    return {
      'Date & Time': rec.startDate,
      'Interviewer Name': rec.interviewerFullName,
      'Recruiter Name' : rec.assignedRecruiterNames.map(users=> {
        return users.firstName;
      }).join(', '),
      'Interview Type': rec.interviewStepName,
      'Interview Step Status': rec.interviewStepStatusName,
      'Candidate Name' : rec.applicantFullName,
      'Mobile No' : rec.applicantPhone?rec.applicantPhone:'',
      'Role' : rec.jobCategoryName,
      'Technology' : rec.technologyName,
      'Candidate Status' : rec.candidateStatus    ///modify once API work is done.
    }
  });
  return this.newJson;
}
transformPhoneNumber(phone:string) {

    const areaCodeStr = phone.slice(0,3);
    const midSectionStr = phone.slice(3,6);
    const lastSectionStr = phone.slice(6);

    return `${areaCodeStr}-${midSectionStr}-${lastSectionStr}`;
  }

  goToInterviewScheduleList(data){
    this._router.navigate([`/view-scheduled-interview-list/`+ data.jobId], { state: { data: {applicantData: data.applicantData,jobId: data.jobId} } });
  }
}
